export default "/images/payper.png?6e446145b1860da10cff8bf501e71ba9";